import React from 'react';
import {observer} from 'mobx-react';
import {MiniOrbitHeaderComponent} from "./header/mini-orbit-header.component";
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {MiniOrbitContentComponent, MiniOrbitContentType} from './content/mini-orbit-content.component';
import {MINI_ORBIT} from '../../themes/css-global-classes';
import {HoverNavigationButtonComponent} from "./hover-navigation-button/hover-navigation-button.component";
import {ThemeProvider} from "styled-components";




export interface MiniOrbitPageComponentProps {
    content: MiniOrbitContentType;
}
export const MiniOrbitPageComponent = observer(
    class MiniOrbitPageComponent extends OrbitComponent<MiniOrbitPageComponentProps> {

        componentDidMount() {
            super.componentDidMount();
            this.services.dom.html.classList.add(MINI_ORBIT);
        }

        private _renderHoverNavigationButton() {
            if (this.services.miniOrbit.currentMiniOrbitConfig?.useIosDesign) {
                return <HoverNavigationButtonComponent/>;
            }
        }

        render() {
            return (
            <>    
                <MiniOrbitHeaderComponent/>
        
                <ThemeProvider theme={this.services.theme.mainContentTheme}>
                    <MiniOrbitContentComponent content={this.props.content}/>
                </ThemeProvider>
                
                {this._renderHoverNavigationButton()}
            </>);
        }
    }
);